import React from "react";
import { Form } from 'react-bootstrap'
import { Checkbox } from 'react-input-checkbox';
import 'react-input-checkbox/lib/react-input-checkbox.min.css';

interface IProps {
    children: React.ReactNode,
    value: boolean,
    disabled?: boolean,
    changeByCheckbox?: boolean,
    onChange?: (event: React.SyntheticEvent) => void;
}

export class ComplexCheckbox extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);

        this.onClickHandler = this.onClickHandler.bind(this);
    }

    onClickHandler(evt: React.MouseEvent<HTMLDivElement, MouseEvent>) {
        if (this.props.hasOwnProperty("changeByCheckbox") && this.props.changeByCheckbox) return;
        evt.preventDefault();
        if (this.props.onChange)
            this.props.onChange(evt);
    }

    render() {
        return (
            <Form.Group onClick={this.onClickHandler}>
                <label className={"chbxCust" + (this.props.value ? " selected" : "")}>
                    <Form.Check type="checkbox">
                        <Checkbox theme="bootstrap-checkbox"
                            children={this.props.children}
                            value={this.props.value}
                            onChange={this.props.onChange}></Checkbox>
                    </Form.Check>
                </label>
            </Form.Group>
        );
    }
}

export default ComplexCheckbox;